import React, { useState } from 'react';
import { TouchableOpacity, Alert } from 'react-native';
import { Trash2 } from 'lucide-react-native';
import { Text, useThemeName } from '@tamagui/core';
import { useTranslation } from 'react-i18next';
import { XStack } from '@tamagui/stacks';

interface DeleteAccountButtonProps {
  onDelete?: () => void;
}

const DeleteAccountButton: React.FC<DeleteAccountButtonProps> = ({ onDelete }) => {
  const themeName = useThemeName();
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation();

  const handleDeleteAccount = () => {
    Alert.alert(
      'Usunięcie konta',
      'Czy na pewno chcesz usunąć swoje konto? Ta operacja jest nieodwracalna.',
      [
        {
          text: 'Anuluj',
          style: 'cancel',
        },
        {
          text: 'Usuń konto',
          style: 'destructive',
          onPress: () => {
            setIsDeleting(true);
            setTimeout(() => {
              setIsDeleting(false);
              onDelete?.();
              Alert.alert('Sukces', 'Twoje konto zostało usunięte.');
            }, 2000);
          },
        },
      ]
    );
  };

  const backgroundColor = themeName === 'dark' ? '#374151' : '#f3f4f6';
  const borderColor = themeName === 'dark' ? '#4b5563' : '#d1d5db';
  const textColor = themeName === 'dark' ? '#ffffff' : '#374151';
  const iconColor = themeName === 'dark' ? '#ef4444' : '#dc2626';

  return (
    <TouchableOpacity onPress={handleDeleteAccount} disabled={isDeleting}>
      <XStack
        alignItems="center"
        paddingHorizontal="$3"
        paddingVertical="$2"
        borderRadius="$4"
        backgroundColor={backgroundColor}
        borderWidth={1}
        borderColor={borderColor}
        space="$2"
        opacity={isDeleting ? 0.6 : 1}
      >
        <Trash2 size={16} color={iconColor} />
        <Text 
          fontSize="$3" 
          color={textColor} 
          fontWeight="600"
        >
          {isDeleting ? t('common.deleting') : t('common.deleteAccount')}
        </Text>
      </XStack>
    </TouchableOpacity>
  );
};

export default DeleteAccountButton;
